import React from "react";

import { IoChevronBackOutline } from "react-icons/io5";
import { Nav } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { useNavigate, useParams } from "react-router-dom";

import Logo from "../../common/images/logo.png";
import { PALETTE } from "../../common/ThemeConstants";
import { useWindowWidth } from "../../api/useWindowWidth";
import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import { useSmartName } from "../../api/useSmartName";

export default function PlanHeader({
  title,
  image,
  showInfo,
  info = "",
  subtitle = undefined,
  showBackground = true,
  backTo = undefined,
  showLogo = false,
}) {
  const { idPlan } = useParams();
  const width = useWindowWidth();
  const navigate = useNavigate();
  const parseName = useSmartName();

  const abbreviateTitle = parseName(title, 24, 40);

  const goTo = () => {
    navigate(`/workout/${idPlan}/Details`);
  }

  return (
    <NavbarResponsive showBackground={showBackground}>
      <Container>
        <Nav className="flex-row">
          <div
            className="align-self-center flex back-button"
            style={{ marginRight: "1rem" }}
          >
            <IoChevronBackOutline
              onClick={() => {
                backTo === undefined ? navigate(-1) : navigate(backTo);
              }}
              size={24}
              style={{ cursor: "pointer" }}
              color={PALETTE.TRUEGRAY}
            />
          </div>
          {showInfo ? (
            <div
              onClick={goTo}
              style={{ textDecoration: "none" }}
            >
              <div className="d-flex align-items-center">
                {image && (
                  <img
                    src={image}
                    className="rounded-circle me-2"
                    alt={title}
                    style={{ width: 40, height: 40, objectFit: "cover", cursor: "pointer" }}
                  />
                )}
                <div className="text-start">
                  <p
                    className="title-clickable clickable"
                    style={{ fontSize: 17, fontWeight: "bold", margin: 0 }}
                  >
                    {abbreviateTitle}
                  </p>
                  <span
                    className="subtitle-clickable"
                    style={{ fontSize: 13, margin: 0 }}
                  >
                    {info}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ textDecoration: "none" }}>
              <div className="text-center">
                {subtitle ? (
                  <>
                    <p style={{ fontSize: 17, fontWeight: "bold", margin: 0 }}>
                      {abbreviateTitle}
                    </p>
                    <span style={{ fontSize: 13, margin: 0 }}>{subtitle}</span>
                  </>
                ) : (
                  <p style={{ color: PALETTE.DARK, fontSize: 17, margin: 0 }}>
                    {abbreviateTitle}
                  </p>
                )}
              </div>
            </div>
          )}
        </Nav>
        {showLogo && (
          <div className="align-self-center" style={{ width: 70 }}>
            <img
              src={Logo}
              style={{ width: "100%" }}
              alt="Federico Bartoli PT"
            />
          </div>
        )}
      </Container>
    </NavbarResponsive>
  );
}
